export function textValidator(st:string) {
  return st[0] === ' ' ? '' : st.replace(/\s+|\s+$/gm, ' ');
}
